module.exports = __webpack_public_path__ + "static/media/Thumb_1920x384_LCSAcademics.8be104ef.jpeg";